import type { PropsWithChildren } from "react";
import { Toaster } from "sonner";

export type ToastProviderProps = PropsWithChildren;

const ToastProvider = ({ children }: ToastProviderProps) => {
  return (
    <>
      <Toaster
        position="bottom-right"
        toastOptions={{
          duration: 3000,
          style: { fontFamily: "Nunito Variable" },
        }}
      />
      {children}
    </>
  );
};

export default ToastProvider;
